const UseCaseCard = ({ title, description, image, tag }) => {
  return (
    <div className="usecase-card">

      {/* Image */}
      <img
        src={image}
        alt={title}
        className="usecase-img"
      />

      {/* Overlay */}
      <div className="usecase-overlay" />

      {/* Optional Tag */}
      {tag && <span className="usecase-badge">{tag}</span>}

      {/* Content */}
      <div className="usecase-content text-start">
        <h4 className="mb-1 font-bold text-white">{title}</h4>

        {description && (
          <p className="text-light font8 mb-3">
            {description}
          </p>
        )}

        <button className="usecase-btn hide">
          Explore →
        </button>
      </div>

    </div>
  );
};

export default UseCaseCard;